import ArchiveModal from '@atlassian/jira-project-archive-modal/src/async';
import { connect } from '@atlassian/jira-react-redux';
import {
	getBaseUrlSelector,
	getProjectIdSelector,
	getProjectTypeSelector,
} from '../../../state/context/selectors';
import { projectNameSelector, projectKeySelector } from '../../../state/entities/selectors';
import type { AppState } from '../../../state/types';
import { archiveProjectSuccess, closeArchiveProjectModal } from '../../../state/ui/actions';

const mapStateToProps = (state: AppState) => ({
	projectId: getProjectIdSelector(state),
	projectName: projectNameSelector(state),
	projectType: getProjectTypeSelector(state),
	projectKey: projectKeySelector(state),
	baseUrl: getBaseUrlSelector(state),
	isProjectSimplified: true,
	onArchiveSuccessFlagRestore: undefined,
});

const mapDispatchToProps = {
	onClose: closeArchiveProjectModal,
	onArchiveSuccess: archiveProjectSuccess,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveModal);
